import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import logoSuperDucha from "../../../../assets/images/logo-super-tanque.png";
import { TextContainer } from "./FailedPaymentStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemLaundryStyles";
import { LaundryStore, restartInteraction } from "../../../../stores/LaundryStore/LaundryStore";

const FailedPayment: React.FC = () => {
  const { errorMsg } = useUnit(LaundryStore);

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleRestart();
    }, 7500);

    return () => clearTimeout(timeout);
  }, []);

  const handleRestart = () => {
    restartInteraction();
  };

  const msg = errorMsg?.length ? errorMsg : "Pagamento não efetuado";

  return (
    <GradientContainer onClick={handleRestart}>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>{msg}</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default FailedPayment;
